import renovationHouseFeaturesSchema from 'constants/wizards/renovation-house-features';
import type { CO2CalculatorInput } from 'graphql/generated/graphql';
import type { TCO2CalculatorFormFields } from 'components/calculators/RenovationHouseForm/types';
import requireValue from 'utils/requireValue';

export const whitelistedPropsCO2Calculator: Array<keyof CO2CalculatorInput> = [
  'step',
  'heated_living_area',
  'kind_of_house',
  'energy_standard',
  'renovations',
  'is_solar_heating_system',
  'solar_heating_system_type',
  'number_of_people',
  'heating_system',
  'age_of_heating_system',
  'temperature',
  'hot_water_producer',
  'amount_of_hot_water',
  'is_devices_younger_than_10_years',
  'power_consumers',
  'is_solar_power_system',
  'solar_power_system_size',
  'solar_power_system_consuming_percentage',
];

export const whitelistedProps = [
  'name',
  'zip',
  'country',
  'form_values.house_area',
  'form_values.number_of_floors',
  ...whitelistedPropsCO2Calculator.map(
    (key) => `calculations.co2_emissions_before.form_values.${key}`,
  ),
  ...renovationHouseFeaturesSchema.flatMap((feature) =>
    Array.isArray(feature.form) ? feature.form.map(({ name }) => `form_values.${name}`) : [],
  ),
];

export const initialValuesCO2Calculator: TCO2CalculatorFormFields = {
  heated_living_area: null,
  kind_of_house: null,
  energy_standard: null,
  renovations: [],
  is_solar_heating_system: false,
  solar_heating_system_type: null,
  number_of_people: null,
  heating_system: null,
  age_of_heating_system: null,
  temperature: null,
  hot_water_producer: null,
  amount_of_hot_water: null,
  is_devices_younger_than_10_years: false,
  power_consumers: [],
  is_solar_power_system: false,
  solar_power_system_size: null,
  solar_power_system_consuming_percentage: null,
};

/**
 * The mutation input of the CO2 calculator step. Its schema requires these fields before the step
 * is submitted, so the values are sent unchanged; a throw is the request the server rejected.
 */
export const toCO2CalculatorInput = (values: TCO2CalculatorFormFields): CO2CalculatorInput => ({
  ...values,
  heated_living_area: requireValue(values.heated_living_area, 'heated_living_area'),
  kind_of_house: requireValue(values.kind_of_house, 'kind_of_house'),
  energy_standard: requireValue(values.energy_standard, 'energy_standard'),
  number_of_people: requireValue(values.number_of_people, 'number_of_people'),
  heating_system: requireValue(values.heating_system, 'heating_system'),
  is_solar_heating_system: requireValue(values.is_solar_heating_system, 'is_solar_heating_system'),
  age_of_heating_system: requireValue(values.age_of_heating_system, 'age_of_heating_system'),
  temperature: requireValue(values.temperature, 'temperature'),
  hot_water_producer: requireValue(values.hot_water_producer, 'hot_water_producer'),
  amount_of_hot_water: requireValue(values.amount_of_hot_water, 'amount_of_hot_water'),
  is_devices_younger_than_10_years: requireValue(
    values.is_devices_younger_than_10_years,
    'is_devices_younger_than_10_years',
  ),
  power_consumers: requireValue(values.power_consumers, 'power_consumers'),
  is_solar_power_system: requireValue(values.is_solar_power_system, 'is_solar_power_system'),
});
